import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FeaturesDBCode, FeaturesList } from 'src/app/interface/features.interface';

@Component({
  selector: 'app-shared-features-selector',
  templateUrl: './shared-features-selector.component.html',
  styleUrls: ['./shared-features-selector.component.scss']
})
export class SharedFeaturesSelectorComponent implements OnChanges {

  @Input() featuresForRoles: FeaturesDBCode[] = [];
  @Input() userFeatures: { feature: string; enable: boolean }[] = [];
  @Input() featuresList: FeaturesList[] = [];
  @Output() featureChange = new EventEmitter<FeaturesDBCode>();

  checkedMap: Map<FeaturesDBCode, boolean> = new Map();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userFeatures'] || changes['featuresList'] || changes['featuresForRoles']) {
      this.buildCheckedMap();
    }
  }

  private buildCheckedMap(): void {
    this.checkedMap = new Map();
    for (const featureCode of this.featuresForRoles) {
      const featureId = this.featuresList.find(f => f.code === featureCode)?.id;
      if (!featureId) {
        this.checkedMap.set(featureCode, false);
        continue;
      }
      const isChecked = (this.userFeatures || []).some(f => f.feature === featureId && f.enable);
      this.checkedMap.set(featureCode, isChecked);
    }
  }

  onChange(featureCode: FeaturesDBCode): void {
    this.checkedMap.set(featureCode, !this.checkedMap.get(featureCode));
    this.featureChange.emit(featureCode);
  }
}
